export * from './reports.service';
import { ReportsService } from './reports.service';
export * from './version.service';
import { VersionService } from './version.service';
export const APIS = [ReportsService, VersionService];
